export default "__VITE_ASSET__Cd2mSmsL__"